export default "__VITE_ASSET__1ba9bcdd__"